import styled from "styled-components";
import React, { useState } from "react";
import {
  Box,
  MenuItem,
  IconButton,
  Popover,
  ClickAwayListener,
  Popper,
  Paper,
} from "@mui/material";
import { Icon } from "@iconify/react";
import { COLORS } from "../contants/colors";
import { useLanguageContext } from "../languageContext";
import { useTranslation } from "react-i18next";

const MorePopover = ({
  showEdit = false,
  showDetails = false,
  canDelete = true,
  showPin = false,
  isPinned = false,
  onPinALert,
  handleClick,
  open,
  setOpen,
  anchorEl,
  top = 0,
  onDelete,
  onUpdate,
  onOpenDetails,
  showShare = false,
  onShare,
  styles = null,
}) => {
  const { t } = useLanguageContext();
  const { i18n } = useTranslation();

  return (
    <MoreWrapper top={top} dir={i18n.language === "ar" ? "rtl" : "ltr"}>
      <IconButton onClick={handleClick}>
        <Box
          colorRendering={"red"}
          component={Icon}
          icon={"eva:more-horizontal-fill"}
          width={20}
          height={20}
          color={COLORS.gray500}
        />
      </IconButton>
      {anchorEl && (
        <Popper
          open={!!anchorEl && open}
          anchorEl={anchorEl}
          placement={i18n.language === "ar" ? "bottom-start" : "bottom-end"}
          style={{ zIndex: 1300 }}
        >
          <ClickAwayListener onClickAway={() => setOpen(false)}>
            <Paper
              elevation={2}
              sx={{
                p: 1,
                width: 140,
                borderRadius: "8px",
                backgroundColor: "white",
                "& .MuiMenuItem-root": {
                  px: 1,
                  typography: "body2",
                  borderRadius: 0.75,
                  fontFamily: "Din",
                  "& svg": { ml: 1, width: 20, height: 20 },
                },
              }}
            >
              {showPin &&
                (isPinned ? (
                  <MenuItem
                    onClick={() => {
                      onPinALert();
                      setOpen(false);
                    }}
                  >
                    <Box
                      component={Icon}
                      icon={"stash:pin-thumbtack-duotone"}
                    />{" "}
                    {t("unpin")}
                  </MenuItem>
                ) : (
                  <MenuItem
                    onClick={() => {
                      onPinALert();
                      setOpen(false);
                    }}
                  >
                    <Box component={Icon} icon={"stash:pin-thumbtack"} />{" "}
                    {t("pin")}
                  </MenuItem>
                ))}
              {showDetails && (
                <MenuItem
                  onClick={() => {
                    onOpenDetails();
                    setOpen(false);
                  }}
                >
                  <Box component={Icon} icon={"uil:chart"} /> {t("details")}
                </MenuItem>
              )}
              {showEdit && (
                <MenuItem
                  onClick={() => {
                    onUpdate();
                    setOpen(false);
                  }}
                >
                  <Box component={Icon} icon={"eva:edit-2-outline"} />
                  {t("edit")}
                </MenuItem>
              )}
              {canDelete && (
                <MenuItem
                  onClick={() => {
                    onDelete();
                    setOpen(false);
                  }}
                >
                  <Box component={Icon} icon={"eva:trash-2-outline"} />{" "}
                  {t("delete")}
                </MenuItem>
              )}
              {showShare && (
                <MenuItem
                  onClick={() => {
                    onShare();
                    setOpen(false);
                  }}
                >
                  <Box component={Icon} icon={"eva:share-outline"} />{" "}
                  {t("share")}
                </MenuItem>
              )}
            </Paper>
          </ClickAwayListener>
        </Popper>
      )}
      {/* <Popover
        container={anchorEl?.parentNode}

        PaperProps={
          styles
            ? styles
            : {
                sx: {
                  p: 1,
                  width: 200,
                  overflow: "inherit",
                },
              }
        }
        open={open}
        anchorEl={anchorEl}
        onClose={() => setOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        arrow="left-top"
        sx={{
          mt: -1,
          width: 140,
          "& .MuiMenuItem-root": {
            px: 1,
            typography: "body2",
            borderRadius: 0.75,
            fontFamily: "Din",
            "& svg": { ml: 1, width: 20, height: 20 },
          },
        }}
      >
        {canDelete && (
          <MenuItem
            onClick={(id) => {
              onDelete(id);
              setOpen(false);
            }}
          >
            <Box component={Icon} icon={"eva:trash-2-outline"} /> {t("delete")}
          </MenuItem>
        )}
        {showDetails && (
          <MenuItem
            onClick={(id) => {
              onOpenDetails(id);
              setOpen(false);
            }}
          >
            <Box component={Icon} icon={"uil:chart"} /> {t("details")}
          </MenuItem>
        )}
        {showEdit && (
          <MenuItem
            onClick={(id) => {
              onUpdate(id);
              setOpen(false);
            }}
          >
            <Box component={Icon} icon={"eva:edit-2-outline"} /> {t("edit")}
          </MenuItem>
        )}
      </Popover> */}
    </MoreWrapper>
  );
};

const MoreWrapper = styled.div`
  position: absolute;
  top: ${(p) => p.top}px;
  right: ${(p) => (p.dir == "rtl" ? "auto" : "10px")};
  left: ${(p) => (p.dir == "ltr" ? "auto" : "10px")};
`;
export default MorePopover;
